<template>
  <el-row>
    <el-col :span="16">
      <div class="list" v-infinite-scroll="load" :infinite-scroll-disabled="!pageInfo.hasMore"
           :infinite-scroll-distance="50">
        <div class="list-item" v-for="(item,i) in logList" :key="i">
          <div class="list-item-info" :class="item.fromUserType===1?'replay':null">
            <span>{{ item.fromNickName }}</span>
            <span>{{ item.sendTime }}</span>
          </div>
          <div class="list-item-log" :class="item.fromUserType===1?'replay':null">
            <el-avatar :size="50" :src="item.fromAvatar"></el-avatar>
            <div class="log">
              <div v-if="item.msgType===-1">{{ item.content }}</div>
              <el-image style="width:100px;" v-else-if="item.msgType===-2" :src="showImage(item)"
                        :preview-src-list="[showImage(item)]"></el-image>
              <div v-else>【不支持的消息类型】：{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="8">
      <div class="customer">
        <h1>客户信息</h1>
        <div class="split">
          <span>姓名:{{ userInfo.realName }}</span>
          <span>ID:{{ userInfo.userId }}</span>
        </div>
        <div class="split">
          <span>标签:{{ userInfo.tagName }}</span>
          <span>性别:{{ userInfo.gender == 0 ? '未知' : userInfo.gender == 1 ? '男' : '女' }}</span>
        </div>
        <div class="split">
          <span>电话:{{ userInfo.phoneNumber }}</span>
          <span>备用电话:{{ userInfo.notePhone }}</span>
        </div>
        <div class="split">
          <span>QQ:{{ userInfo.qq }}</span>
          <span>微信:{{ userInfo.wechat }}</span>
        </div>
        <div class="split">
          <span class="text-overflow">来源页:{{ userInfo.refererUrl }}</span>
          <el-button class="copy" type="text" @click="copy(userInfo.refererUrl)">复制</el-button>
        </div>
        <div class="split">
          <span class="text-overflow">着陆页:{{ userInfo.pageUrl }}</span>
          <el-button class="copy" type="text" @click="copy(userInfo.pageUrl)">复制</el-button>
        </div>
        <div class="split">
          <span class="text-overflow">最近咨询页:{{ userInfo.latestPageUrl }}</span>
          <el-button class="copy" type="text" @click="copy(userInfo.latestPageUrl)">复制</el-button>
        </div>
        <div class="split">
          <span>推广码:{{ userInfo.scode }}</span>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import api from "plus/api";

export default {
  props: {
    chatId: String,
    userId: String,
  },
  async created() {
    await this.getInfo();
    await this.getLog();
  },
  data() {
    return {
      pageInfo: {
        limit: 10,
        page: 1,
        hasMore: false,
        sortBy: "SendTime ASC",
      },
      logList: [],
      userInfo: {},
      loading: false,
    };
  },
  methods: {
    async load() {
      if (this.pageInfo.hasMore && !this.loading) {
        this.pageInfo.page++;
        await this.getLog();
      }
    },
    async getLog() {
      this.loading = true;
      const response = await api.chat.getChatInfo({
        chatId: this.chatId,
        ...this.pageInfo,
      });
      if (response.data.success) {
        const {hasMore, limit, page, total, items} =
            response.data.data;
        this.pageInfo = {
          ...this.pageInfo,
          hasMore,
          limit,
          page,
          total,
        };
        this.logList = this.logList.concat(items);
        this.loading = false;
      } else {
        this.loading = false;
        this.$message.error(response.data.msg);
      }
    },
    async getInfo() {
      const response = await api.chat.getUserInfo({
        chatId: this.chatId,
        userId: this.userId,
      });
      if (response.data.success) {
        this.userInfo = response.data.data;
      } else {
        this.$message.error(response.data.msg);
      }
    },
    showImage(item) {
      return JSON.parse(item.content).url;
    },
    copy(str) {
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =
          document.getSelection().rangeCount > 0
              ? document.getSelection().getRangeAt(0)
              : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.$message.success('复制成功');
    }
  },
};
</script>

<style lang="less" scoped>
.list {
  width: 100%;
  height: 600px;
  overflow: auto;
  border: 1px solid #cccccc;
  padding-top: 20px;

  .list-item {
    margin-bottom: 42px;
    margin-left: 20px;
    margin-right: 20px;
    padding: 20px;
    box-shadow: 0 0 10px #ccc;

    &:last-child {
      margin-bottom: 20px;
    }

    .list-item-info {
      margin-bottom: 10px;
      border-bottom: 1px dashed #cccccc;

      span {
        margin-right: 20px;
      }
    }

    .list-item-log {
      display: flex;

      .log {
        flex: 1;
        margin: 0 20px;
        padding: 10px;
        border-radius: 4px;
        background: #ffffff;
        color: #666666;
        box-shadow: 0 0 10px #ccc;
      }
    }

    .replay {
      display: flex;
      flex-direction: row-reverse;

      .log {
        background-color: #236cff;
        color: #FFFFFF;
      }
    }
  }
}

.customer {
  padding: 10px;

  .split {
    display: flex;

    span {
      flex: 1;
    }

    .text-overflow {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .copy {
      padding: 0 10px;
    }
  }
}
</style>
